export default function finalGrade() {
    return {

       roster: [],
       
        fethedAcademicYear: '',
        fethedAcademicTerm: '',
        fethedAcademicSession: '',
        fethedSerialId: '',
        fetchedEventId: '',
        fetchedTitle: '',
        fetchedSection: '',
        fetchedFee: '',
        fetchedAdds: '',
        fetchedMax: '',
        fetchedAllowGradeUpdate: false,
        fetchedStartDate: '',
        fetchedEndDate: '',
        fetchedPercentage: '',
       
        studentData: '',
        isSuccessMessage: false,
        isStudentEmailSuccessMessage: false,
        isAdminEmailSuccessMessage: false,
        isUpdateMessage: false,
        message: '',
        studentEmailMessage: '',
        adminEmailMessage:'',
        updateMessage:'',
        updateRowMessage:[],
        selectedGradeOption: [],
        studentsForEmail: [],
        isUpdateGradedSectionsMessage: false,
        updateGradedSectionsMessage: '',
        isSaveRosterGradeSectionsEmail: false,
        saveRosterGradeSectionsEmailMessage: '',
        missingStudentDataFromRoster: '',
        isMissingStudentEmailSuccessMessage: false,
        missingStudentEmailSuccessMessage: '',
        notSelectedCount: 0,
        matchedCount: 0,
        finalGradeReceived:false,
        formatDate(dateValue) {
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            const formattedDate = new Date(dateValue).toLocaleDateString(undefined, options);
            return formattedDate;
        },
        formatValue(value) {
            // Convert value to 0.00 format
            return parseFloat(value).toFixed(2);
        },
        formatMeetingDate(dateValue) {
            const date = new Date(dateValue);
            const month = date.getMonth() + 1; // Month is zero-based, so add 1
            const day = date.getDate();
            const year = date.getFullYear();
            return `${month}-${day}-${year}`;
        },
        formatEventId(eventId) {
            if (eventId != null) {
                return eventId.replace("_", " ");
            }
        },
        confirmSubmit() {
            this.notSelectedCount = 0;
            for (let k = 0; k < this.selectedGradeOption.length; k++) {
                if (this.selectedGradeOption[k] === "" || this.selectedGradeOption[k] === "Select") {
                    this.notSelectedCount += 1;
                }
            }
            if (this.notSelectedCount <= 0) {
                this.isUpdateGradedSectionsMessage = true;
                this.updateGradedSectionsMessage = "";
                document.getElementById("btnConfirm").click();
            }        
            else {
            this.isUpdateGradedSectionsMessage = false;
            this.updateGradedSectionsMessage = "You must be submit grade for each student";
                this.updateRowMessage = [];
                this.message = "";
                this.adminEmailMessage = "";
                this.missingStudentDataFromRoster = "";
                this.missingStudentEmailSuccessMessage = "";
            }
        },
        resetForm() {
           
            this.message = "";
            this.adminEmailMessage = "";
            this.updateGradedSectionsMessage = "";
            this.updateRowMessage = [];
            this.selectedGradeOption = [];
            this.missingStudentDataFromRoster = "";
            this.missingStudentEmailSuccessMessage = "";
            this.bindClassRoster();
        },
        bindClassRoster() {
            this.selectedGradeOption = [];
            // document.getElementById("peopleCodeId").value
            fetch('/api/Instructors/GetRosterGradeEntry', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    AcademicYear: document.getElementById("academicYear").value,
                    AcademicTerm: document.getElementById("academicTerm").value,
                    SerialId: document.getElementById("serialId").value,
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {

                        this.roster = response.roster;
                      
                        this.fethedAcademicYear = response.academicYear;
                        this.fethedAcademicTerm = response.academicTerm;
                        this.fethedAcademicSession = response.academicSession;
                        this.fethedSerialId = response.serialId;
                        this.fetchedEventId = response.eventId;
                        this.fetchedTitle = response.title;
                        this.fetchedSection = response.section;
                        this.fetchedFee = response.fee;
                        this.fetchedAdds = response.adds;
                        this.fetchedMax = response.max;
                        this.fetchedAllowGradeUpdate = response.allowGradeUpdate;
                        this.fetchedStartDate = response.startDate;
                        this.fetchedEndDate = response.endDate;
                        this.fetchedPercentage = response.percentage;
                        this.finalGradeReceived = response.finalGradeReceived;
                        for (var i = 0; i < this.roster.length; i++) {
                           // if (this.roster.gradeOptions.length > 0) {
                                this.selectedGradeOption.push(this.roster[i].finalGrade);
                           // }
                        }
                        this.isSuccessMessage = true;
                    } else {
                        this.isSuccessMessage = false;
                        this.message = response.messages[0];
                    }

                });

        },

        TestPromiseAllSettled() {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/allSettled
        // This feature is well established and works across many devices and browser versions. It’s been 
        // available across browsers since July 2020.
          const promise1 = Promise.resolve( 3 );
          const promise2 = new Promise(( resolve, reject ) =>
            setTimeout( reject, 100, 'foo' ),
            );
          const promises = [ promise1, promise2 ];

          Promise.allSettled( promises ).then(( results ) =>
            results.forEach(( result ) => console.log( result.status ))
            );

          // Expected output:
          // "fulfilled"
          // "rejected"

/* Another test:
          Promise.allSettled([
            Promise.resolve(33),
            new Promise((resolve) => setTimeout(() => resolve(66), 0)),
            99,
            Promise.reject(new Error("an error")),
          ]).then((values) => console.log(values));

          // [
          //   { status: 'fulfilled', value: 33 },
          //   { status: 'fulfilled', value: 66 },
          //   { status: 'fulfilled', value: 99 },
          //   { status: 'rejected', reason: Error: an error }
          // ]
*/
          },

        SaveRosterGradeEntry() {
            this.updateRowMessage = [];
            this.studentsForEmail = [];         
            this.matchedCount = 0;
                if (this.roster.length > 0) {
                    let promises = [];
                    for (let i = 0; i < this.roster.length; i++) {

                    // For each student in roster:
                        if (this.roster[i].gradeOptions.length > 0 && this.roster[i].finalGrade !== this.selectedGradeOption[i]) {
                            let promise = fetch('/api/Instructors/SaveRosterGradeEntry', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    AcademicYear: document.getElementById("academicYear").value,
                                    AcademicTerm: document.getElementById("academicTerm").value,
                                    SerialId: document.getElementById("serialId").value,
                                    StudentId: this.roster[i].studentId,
                                    NewGrade: this.selectedGradeOption[i],
                                })
                            })
                                .then(response => {
                                    if (response.ok) {
                                        return response.json()
                                    }
                                }).then(response => {

                                    if (response.isSuccess) {
                                        this.updateRowMessage[i] = "true";
                                        if (response.sendEmailToStudent) {
                                            this.studentsForEmail.push({
                                                studentName: response.studentName,
                                                studentEmail: response.studenEmail,
                                                studentId: response.studentId,
                                            });

                                            this.SendFinalGradeUpdateEmailToStudent(response.studenEmail, this.fethedSerialId,
                                                this.fetchedTitle, this.fethedAcademicYear,
                                                this.fethedAcademicTerm);

                                        }
                                        this.UpdateGradedSections();

                                        this.isUpdateMessage = true;
                                    } else {
                                        this.updateRowMessage[i] = "false";
                                        this.isUpdateMessage = false;
                                        this.updateMessage = "An unknown error has occurred. Please try again later.";

                                        // This email should explain why SendSaveRosterGradeSectionsEmailToAdmin() wasn't called.
                                        this.SendFailedGradeUpdateEmailToAdmin(document.getElementById("email").value, this.roster[i].studentId, this.roster[i].emailAddress, this.fethedSerialId,
                                            this.fetchedTitle, this.fethedAcademicYear,
                                            this.fethedAcademicTerm);
                                    }

                                });
                            promises.push(promise);
                        }
                        else if (this.roster[i].finalGrade === this.selectedGradeOption[i]) {
                            this.updateRowMessage[i] = "false";
                            this.matchedCount += 1;
                        }
                        else if (this.roster[i].gradeOptions.length <= 0) {
                            this.updateRowMessage[i] = "false";

                        }

                    }
                    if (this.roster.length === this.matchedCount) {
                        this.updateGradedSectionsMessage = true;
                        this.updateGradedSectionsMessage = "No Roster grade sections are changed.";
                    }
                    else {
                        const trueElements = this.updateRowMessage.filter((item) => item === 'true');
                        const falseElements = this.updateRowMessage.filter((item) => item === 'false');
                        if (!this.finalGradeReceived) {
                            this.bindClassRoster();

                            Promise.all(promises)
                                .then(() => {
                                    this.SendSaveRosterGradeSectionsEmailToAdmin(this.studentsForEmail, document.getElementById("email").value,
                                        this.missingStudentDataFromRoster, "posted", this.fethedSerialId, this.fetchedTitle, this.fethedAcademicYear,
                                        this.fethedAcademicTerm);
                                });
                        }
                        if (this.finalGradeReceived) {
                            this.bindClassRoster();

                            Promise.all(promises)
                                .then(() => {
                                    this.SendSaveRosterGradeSectionsEmailToAdmin(this.studentsForEmail, document.getElementById("email").value,
                                        this.missingStudentDataFromRoster, "changed", this.fethedSerialId, this.fetchedTitle, this.fethedAcademicYear,
                                        this.fethedAcademicTerm);
                                });
                        }
                    }
                }
            
        },
        UpdateGradedSections() {
           
                        fetch('/api/Instructors/UpdateGradedSections', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                AcademicYear: document.getElementById("academicYear").value,
                                AcademicTerm: document.getElementById("academicTerm").value,
                                SerialId: document.getElementById("serialId").value,
                             
                            })
                        })
                            .then(response => {
                                if (response.ok) {
                                    return response.json()
                                }
                            }).then(response => {

                                if (response.isSuccess) {
                                                                                                       
                                    this.updateGradedSectionsMessage = true;
                                    this.updateGradedSectionsMessage = "Roster grade sections updated successfully.";
                                    this.bindClassRoster();
                                } else {
                                    this.isUpdateGradedSectionsMessage = false;
                                    this.updateGradedSectionsMessage = "An unknown error has occurred. Please try again later.";
                                 
                                }

                        });
                   
        },
        SendFinalGradeUpdateEmailToStudent(toEmail, serialId, courseTitle, academicYear, academicTerm) {
            var temp = "";
            fetch('/api/Instructors/SendFinalGradeUpdateEmailToStudent', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ToEmail: toEmail,
                    SerialId: serialId,
                    CourseTitle: courseTitle,
                    AcademicYear: academicYear,
                    AcademicTerm: academicTerm,
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.isStudentEmailSuccessMessage = true;
                        this.studentEmailMessage="";
                    }
                    else {
                        this.isStudentEmailSuccessMessage = false;
                        this.studentEmailMessage = "Student email not sent, An unknown error has occurred. Please try again later."
                    }
                });
        },
        SendFailedGradeUpdateEmailToAdmin(fromEmail, studentId, studentEmail, serialId, courseTitle, academicYear, academicTerm) {
            var temp = "";
            fetch('/api/Instructors/SendFailedGradeUpdateEmailToAdmin', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    Fromemail: fromEmail,
                    StudentId: studentId,
                    StudentEmail: studentEmail,
                    SerialId: serialId,
                    CourseTitle: courseTitle,
                    AcademicYear: academicYear,
                    AcademicTerm: academicTerm,
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.isStudentEmailSuccessMessage = true;
                        this.studentEmailMessage = "";
                    }
                    else {
                        this.isStudentEmailSuccessMessage = false;
                        this.studentEmailMessage = "Student email not sent, An unknown error has occurred. Please try again later."
                    }
                });
        },

        SendSaveRosterGradeSectionsEmailToAdmin(studentData, fromEmail, missingStudentsFromRosterData, postedChanged, serialId, courseTitle, academicYear, academicTerm) {
           
            fetch('/api/Instructors/SendSaveRosterGradeSectionsEmailToAdmin', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    StudentData:studentData,
                    FromEmail: fromEmail,
                    SerialId: serialId,
                    CourseTitle: courseTitle,
                    AcademicYear: academicYear,
                    AcademicTerm: academicTerm,
                    PostedChanged: postedChanged,
                    MissingStudentsfromRosterData: missingStudentsFromRosterData,

                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json()
                    }
                }).then(response => {

                    if (response.isSuccess) {
                        this.isSaveRosterGradeSectionsEmail = true;
                        this.saveRosterGradeSectionsEmailMessage = "";
                        if (this.missingStudentDataFromRoster != "") {
                            this.isMissingStudentEmailSuccessMessage = true;
                            this.missingStudentEmailSuccessMessage = "Email sent."
                            this.missingStudentDataFromRoster = "";
                        }
                        else {
                            this.missingStudentEmailSuccessMessage = "";
                        }
                    }
                    else {
                        this.isSaveRosterGradeSectionsEmail = false;
                        this.saveRosterGradeSectionsEmailMessage = "Roster grade section email to admin not sent, An unknown error has occurred. Please try again later."
                    }
                });
        },
        SendStudentsMissingFromRosterEmail() {
            if (this.missingStudentDataFromRoster == "" || this.missingStudentDataFromRoster == null) {
                this.isMissingStudentEmailSuccessMessage = false;
                this.missingStudentEmailSuccessMessage = "Please enter student details."
            }
            else {
                fetch('/api/Instructors/SendStudentsMissingFromRosterEmail', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        FromEmail: document.getElementById("email").value,
                        StudentData: this.missingStudentDataFromRoster,
                        AcademicYear: document.getElementById("academicYear").value,
                        AcademicTerm: document.getElementById("academicTerm").value,
                        SerialId: document.getElementById("serialId").value
                    })
                })
                    .then(response => {
                        if (response.ok) {
                            return response.json()
                        }
                    }).then(response => {

                        if (response.isSuccess) {
                            this.isMissingStudentEmailSuccessMessage = true;
                            this.missingStudentEmailSuccessMessage = "Email sent."
                            this.missingStudentDataFromRoster = "";
                        }
                        else {
                            this.isMissingStudentEmailSuccessMessage = false;
                            this.missingStudentEmailSuccessMessage = "An unknown error has occurred. Please try again later."
                        }
                    });
            }
        },
        init() {
            this.bindClassRoster();

        }
    }
}